<template>
  <div>
    <table class="dialog-table">
      <thead>
        <tr>
          <th style="min-width: 30vw"></th>
          <th>{{ $t('qty_per_unit') }}</th>
          <th>{{ $t('price_per_unit') }}</th>
          <th>{{ $t('amount_lower') }}</th>
          <th>{{ $t('price_calc_method_short') }}</th>
          <th v-if="!hideRemoveBtn"></th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(row, i) in theModel" :key="row.id">
          <!-- первый столбец — мультиполе -->
          <td style="padding: 10px;" :class="[{ 'error-text': createType !== 0 && !getStorage(row) && row.storagesWithQuantities?.length }]">
            <div class="row no-wrap items-center">
              <span style="font-weight: 500; color: #111; align-self: flex-start;">{{ i+1 }})&nbsp;</span>
              <position-row
                :id="row.id"
                :el="row.pos_with_vcode"
              />
              <span v-if="row.id && positionLockStatus(row)" class="q-ml-xs inline-flex self-start">
                <q-tooltip anchor="top middle" self="center middle">
                  {{ positionLockStatus(row) === 'locked_by_other' ? $t('entity_locked_other_user') : $t('entity_locked_or_other_reason') }}
                </q-tooltip>
                <q-icon name="lock" size="16px" color="warning" />
              </span>
            </div>
          </td>
          <td class="shrink-col">
            <div class="row no-wrap justify-end">
              <!-- @blur="recalcRow(row)" -->
              <native-input
                :ref="'qty_input_'+row.id"
                v-model="row.qty"
                :max-number-value="createType !== 0 ? (getStorage(row)?.Count || 0) : undefined"
                input-type="number"
                :edit-on-click="true"
                :disabledField="!canEdit || !canEditQuantity"
                @update:modelValue="recalcRow(row)"
              />
              <q-select
                flat
                v-model="row.MeasureUnit"
                class="q-mb-xs q-mr-xs thin-input-noborder"
                fill-input
                :bottom-slots="false"
                dense
                outlined
                :disable="!canEdit || !canEditQuantity"
                :label-slot="false"
                hide-bottom-space
                dropdown-icon="expand_more"
                option-value="Id"
                option-label="Name"
                input-debounce="500"
                input-class="text-right"
                :ref="'measure_select_' + row.id"
                :options="
                  storage_pos?.measureUnits ? storage_pos?.measureUnits.Hints : []
                "
              />
            </div>
          </td>

          <td class="shrink-col">
            <native-input
              :ref="'price_input_'+row.id"
              v-model="row.price"
              input-type="number"
              :edit-on-click="true"
              @blur="recalcRow(row)"
              :disabledField="(createType !== 0 || row.PriceType.Id !== 2) || !canEdit"
            />
          </td>

          <td style="font-size: 14px; padding-top: 10px;">{{ row.amount }}</td>

          <td>
            <q-select
              flat
              :disable="createType !== 0 || !canEdit"
              v-model="row.PriceType"
              class="q-mb-xs q-mr-xs thin-input-noborder"
              fill-input
              :bottom-slots="false"
              dense
              outlined
              :label-slot="false"
              hide-bottom-space
              dropdown-icon="expand_more"
              option-value="Id"
              option-label="Name"
              input-debounce="500"
              @update:modelValue="updateRowPrice(row)"
              :ref="'price_select_' + row.id"
              :options="priceOptions"
            />
          </td>

          <td v-if="!hideRemoveBtn">
            <!-- <q-icon
              name="close"
              class="cursor-pointer"
              size="18px"
              color="grey-6"
              @click="remove(row.id)"
              :title="$t('remove')"
            /> -->

            <span
              class="table-remove"
              :title="$t('remove')"
            >
              <app-icon
                name="close"
                width="16px"
                color="#979797"
                hover-color="#616161"
                cursor="pointer"
              />
              <q-menu>
                <q-card>
                  <q-card-section class="row items-center">
                    <q-avatar
                      icon="delete"
                      size="md"
                      color="grey"
                      text-color="white"
                    />
                    <span class="q-ml-sm">
                      {{ $t("sure_delete") }}
                    </span>
                  </q-card-section>

                  <q-card-actions align="right">
                    <q-btn
                      size="sm"
                      flat
                      :label="$t('cancel')"
                      color="dark"
                      v-close-popup
                    />
                    <q-btn
                      size="sm"
                      flat
                      :label="$t('remove')"
                      autofocus
                      color="dark"
                      @click="remove(row.id)"
                      v-close-popup
                    />
                  </q-card-actions>
                </q-card>
              </q-menu>
            </span>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script lang="ts">
import { Component, Prop, Emit, Vue } from "vue-facing-decorator";
import { StorageItemPriceType, V2StorageItemMovementType } from "../../../models/etc/types";
import { CommonEntity, NumericResponse } from "../../../models/interfaces/common";
import { ParameterInstanceContainer } from "../../../models/interfaces/parameters/parameter-models";
import { CommonEntityWithCount } from "../../../models/interfaces/storage/storage-models";
import { storagePositionsStore } from "../../../store/storage/storage-positions";
import { useEntityStore } from "../../../store/heartbeat-workers/useEntityStore";
import { LockedEntityType } from "../../../store/interfaces/types.analytics";
import NativeInput from "../../common/basic/NativeInput.vue";
import PositionRow from "./storageshared/PositionRow.vue";
import AppIcon from "@/components/ui-kit/icon/AppIcon.vue";

export interface PositionLine {
  new_p: boolean;
  id: number;
  amount: number;
  qty: number;
  price: number;
  priceByLastIncome: number;
  MeasureUnit: CommonEntity;
  PriceType: CommonEntity;
  pos: ParameterInstanceContainer[];
  pos_with_vcode: ParameterInstanceContainer[];
  storagesWithQuantities: CommonEntityWithCount[];
  blocked_by_other?: boolean;
}

@Component({
  name: "PositionsTableHtml",
  emits: ['update:modelValue'],
  components: { NativeInput, PositionRow, AppIcon },
})
export default class PositionsTableHtml extends Vue {
  // custom icons
  private infoIconUrl: string = require("@/assets/info-circle.svg");
  // вычисляемое свойство, которое Quasar ожидает в виде строки "img:URL"
  get infoIconName(): string {
    return `img:${this.infoIconUrl}`;
  }

  @Prop({ default: false }) hideRemoveBtn!: boolean;
  @Prop({ default: true }) canEdit!: boolean;
  @Prop({ default: true }) canEditQuantity!: boolean;
  @Prop({ required: true, default: V2StorageItemMovementType.In }) readonly createType!: V2StorageItemMovementType;
  @Prop({ required: true }) modelValue!: PositionLine[];
  @Prop({ default: 0 }) currentStorage!: number;
  
  storage_pos: any = undefined;
  showPosInfoMode: boolean = false;

  get entityStore() {
    return useEntityStore();
  }

  /** Статус блокировки для позиции (только при наличии row.id); undefined если не показывать метку */
  positionLockStatus(row: PositionLine): string | undefined {
    if (!row.id) return undefined;
    const status = this.entityStore.getLockStatus(row.id, LockedEntityType.StorageItem);
    return status && status !== "locked" ? status : undefined;
  }

  created() {
    this.storage_pos = storagePositionsStore();
  }

  get theModel(): PositionLine[] {
    return this.modelValue || [];
  }

  set theModel(v: PositionLine[]) {
    this.$emit("update:modelValue", v);
  }

  @Emit("recalc") emitRecalc() {
    /* noop */
  }

  // width function
  get priceOptions() {
    return [
      {
        Name: this.$t('price_last_receipt'),
        Id: StorageItemPriceType.LastIncome,
      },
      {
        Name: this.$t('set_by_user'),
        Id: StorageItemPriceType.SetByUser,
      },
    ];
  }

  getStorage(row: PositionLine) {
    return row.storagesWithQuantities.find(el => el.Id === this.currentStorage)
  }

  remove(id: string) {
    this.theModel = this.theModel.filter((r: any) => r.id !== id);
    this.emitRecalc();
  }

  async updateRowPrice(row: PositionLine) {
    if (row.id && row.PriceType.Id === StorageItemPriceType.LastIncome) {
      if (row.priceByLastIncome <= 0) {
        const plasti: NumericResponse = await this.storage_pos.getPriceByLastIncome(row.id)
        row.price = plasti.Value
        row.priceByLastIncome = plasti.Value
      } else {
        row.price = row.priceByLastIncome
      }
      this.recalcRow(row)
    }
  }

  recalcRow(row: PositionLine) {
    row.amount = Math.round((row.qty || 0) * (row.price || 0) * 10000) / 10000;
    // принудить обновление массива
    this.theModel = [...this.theModel];
  }
}
</script>

<style scoped>
.error-text {
  color: red !important;
}
.muted {
  color: var(--muted);
}
.strong {
  font-weight: 600;
}
.inp {
  width: 100%;
  box-sizing: border-box;
  padding: 6px 8px;
  font-size: var(--fs);
  border: 1px solid var(--line);
  border-radius: 6px;
  outline: none;
}
.inp:focus {
  border-color: var(--accent);
  box-shadow: 0 0 0 2px #e7f0fe;
}

.table-remove {
  display: inline-flex;
  line-height: 0;
  vertical-align: middle;
}
</style>
